import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import OrgaConfirm from "./OrgaConfirm";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import CreateOrgaName from "./CreateOrgaName";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
import { logout } from "../redux/actions/userActionCreators";
import { setOrganizationId } from "../redux/actions/organizationProfileCreators";

const ConfirmOrgaId = () => {
  const routesWithoutSidebar = [`/profile-organization`];
  const { pathname } = useLocation();
  const shouldInclude = !routesWithoutSidebar.includes(pathname);
  const history = useHistory();
  const storedUser = localStorage.getItem("user");
  const { isAuth } = useSelector((state) => state.user);
  const openInvitation = useSelector(
    (state) => state.confirmInvitation.openConfirm
  );
  const organizationId = JSON.parse(localStorage.getItem("orgaId"));
  const managed_organizations = JSON.parse(storedUser)?.managed_organizations;
  const role = JSON.parse(storedUser)?.role;
  const accountType = JSON.parse(storedUser)?.account_type;
  const publicId = JSON.parse(storedUser)?.public_id;

  const [controlOrga, setControlOrga] = useState(false);
  const [open, setOpen] = useState(false);
  const [orgaId, setOrgaId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  const isMobile = useMediaQuery("(max-width:900px)");
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setControlOrga(managed_organizations?.length > 0 ? false : true);
  }, [localStorage, isAuth]);

  const handleCloseControl = () => {
    setControlOrga(false);
  };

  useEffect(() => {
    setOrgaId(organizationId);
  }, [organizationId]);

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const createOrgaProfile = () => {
    // history.push("/profile-organization");
    setOpenModal(true);
  };

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={
          accountType === "enterprise"
            ? controlOrga
            : !orgaId &&
              !managed_organizations &&
              isAuth &&
              shouldInclude &&
              !openInvitation
        }
        aria-labelledby="draggable-dialog-title"
        disableBackdropClick
        onClose={handleCloseControl}
        maxWidth="xl"
        PaperProps={{ sx: { width: isMobile ? "80%" : "50%", zIndex: 90 } }}
      >
        <Box display="flex" alignItems="center" ml={3}>
          {accountType === "enterprise" ? (
            <Typography
              variant="subtitle3"
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                mt: 2,
                cursor: "pointer",
              }}
              onClick={handleCloseControl}
            >
              <IconButton>
                <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
              </IconButton>
              {t("close")}
            </Typography>
          ) : (
            <>
              <WarningAmberIcon color="error" />
              <DialogTitle id="draggable-dialog-title">Alert!</DialogTitle>{" "}
            </>
          )}
        </Box>
        <DialogContent>
          <DialogContentText>
            {accountType === "enterprise"
              ? t("no_orga")
              : t("create_orga_profile")}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: isMobile && "column",
            gap: isMobile && 1,
            justifyContent: "space-between",
          }}
        >
          {accountType === "free" && (
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                dispatch(logout(publicId, history));
                dispatch(setOrganizationId(null));
              }}
              sx={{ width: isMobile ? "100%" : null}}
              size="small"
              startIcon={<Logout />}
            >
              {t("logout")}
            </Button>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: isMobile && "column",
              gap: isMobile ? 6 : 10,
              width: (isMobile || accountType === "enterprise") && "100%",
            }}
          >
            {accountType === "enterprise" ? (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  setOpenModal(true);
                  handleCloseControl();
                }}
                size="small"
                sx={{ width: "100%", marginRight: "6px" }}
              >
                {t("create_organization")}
              </Button>
            ) : (
              <>
                {/* {isMobile ? (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{ width: "100%" }}
                  >
                    {t("already_have")}
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setOpen(true)}
                    size="small"
                  >
                    {t("already_have")}
                  </Button>
                )} */}
                {isMobile ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => createOrgaProfile()}
                    size="small"
                    sx={{ width: "100%", marginRight: "6px" }}
                  >
                    {t("dont_have")}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => createOrgaProfile()}
                    size="small"
                  >
                    {t("dont_have")}
                  </Button>
                )}
              </>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <OrgaConfirm open={open} handleClose={handleClose} />
      <CreateOrgaName
        open={openModal}
        handleClose={handleCloseModal}
        isMobile={isMobile}
      />
    </div>
  );
};

export default ConfirmOrgaId;
